import { render, staticRenderFns } from "./linkDetail.vue?vue&type=template&id=72ebdeae&scoped=true&"
import script from "./linkDetail.vue?vue&type=script&lang=js&"
export * from "./linkDetail.vue?vue&type=script&lang=js&"
import style0 from "./linkDetail.vue?vue&type=style&index=0&id=72ebdeae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ebdeae",
  null
  
)

export default component.exports